import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=fa93702e&scoped=true&"
import script from "./TabMenu.vue?vue&type=script&lang=js&"
export * from "./TabMenu.vue?vue&type=script&lang=js&"
import style0 from "./TabMenu.vue?vue&type=style&index=0&id=fa93702e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa93702e",
  null
  
)

export default component.exports